<section class="d-flex justify-content-center align-items-center vh-100">
  <button (click)="login()" class="btn btn-primary">
    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
    Login
  </button>
</section>
